"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainNavLinks = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var Icon_1 = require("../../../Icon");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var useDisplayMode_1 = require("./useDisplayMode");
var items_1 = require("./items");
var useMenuControls_1 = require("../../hooks/useMenuControls");
var colors_1 = require("../../colors");
var NavMenu_1 = require("../_shared/NavMenu");
var MainNavLinks = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), siteConfiguration = _a.siteConfiguration, permissions = _a.permissions, colorSet = _a.colorSet, _js = _a._js, activeItem = _a.activeItem;
    var items = (function () {
        var result = [];
        if (!siteConfiguration)
            return result;
        if (siteConfiguration['feature-guide']) {
            result.push({ key: 'guides', el: React.createElement(items_1.GuidesItem, null) });
        }
        if (siteConfiguration['feature-answers']) {
            result.push({ key: 'answers', el: React.createElement(items_1.AnswersItem, null) });
        }
        if (siteConfiguration['feature-courses']) {
            result.push({ key: 'courses', el: React.createElement(items_1.CoursesItem, null) });
        }
        if (siteConfiguration['dev-feature-quizzes']) {
            result.push({ key: 'quizzes', el: React.createElement(items_1.QuizzesItem, null) });
        }
        if (siteConfiguration['feature-teams']) {
            result.push({ key: 'teams', el: React.createElement(items_1.TeamsItem, null) });
        }
        if (siteConfiguration['feature-bi-reports'] && (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewSiteReports)) {
            result.push({ key: 'dashboards', el: React.createElement(items_1.DashboardsItem, null) });
        }
        if (siteConfiguration['feature-app-marketplace']) {
            result.push({ key: 'apps', el: React.createElement(items_1.AppsItem, null) });
        }
        return result;
    })();
    var breakpoint = (0, react_1.useBreakpointValue)({
        base: 'base',
        md: 'md',
        lg: 'lg',
        xl: 'xl',
        fallback: 'xl',
    }, { ssr: false });
    var _b = (0, react_1.useDisclosure)(), isOpen = _b.isOpen, onOpen = _b.onOpen, onClose = _b.onClose;
    var anyIsActive = function (items) { return items.some(function (item) { return item.key === activeItem; }); };
    var getOffsetContent = function (offset) {
        return items.length <= offset ? (React.createElement(React.Fragment, null, items.slice(0, offset).map(function (_a) {
            var key = _a.key, el = _a.el;
            return (React.createElement(useDisplayMode_1.DisplayModeContext.Provider, { value: "main", key: "header-link_".concat(key) }, el));
        }))) : (React.createElement(react_1.Flex, { alignItems: "center" },
            React.createElement(React.Fragment, null, items.slice(0, offset).map(function (_a) {
                var key = _a.key, el = _a.el;
                return (React.createElement(useDisplayMode_1.DisplayModeContext.Provider, { value: "main", key: "header-link_".concat(key) }, el));
            })),
            React.createElement(MoreOptionsDropdown, { underlined: anyIsActive(items.slice(offset)) }, items.slice(offset).map(function (_a) {
                var key = _a.key, el = _a.el;
                return (React.createElement(useDisplayMode_1.DisplayModeContext.Provider, { value: "more", key: "header-link_".concat(key) }, el));
            }))));
    };
    var getContent = function (breakpoint) {
        switch (breakpoint) {
            case 'base':
                return (React.createElement(React.Fragment, null,
                    React.createElement(react_1.Button, { mr: 1, variant: "ghost", onClick: onOpen, "data-testid": "header-hamburger-menu" },
                        React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faBars, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text })),
                    React.createElement(useMenuControls_1.MenuControlsContext.Provider, { value: { onOpen: onOpen, onClose: onClose } },
                        React.createElement(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "full" },
                            React.createElement(react_1.ModalContent, { bg: colors_1.DEFAULT_BACKGROUND_COLOR },
                                React.createElement(react_1.ModalHeader, { color: colors_1.DEFAULT_TEXT_COLOR }, _js('Navigation')),
                                React.createElement(react_1.ModalCloseButton, { color: colors_1.DEFAULT_TEXT_COLOR, mr: 1 }),
                                React.createElement(react_1.ModalBody, null,
                                    React.createElement(react_1.VStack, { alignItems: "stretch", spacing: 0, color: colors_1.DEFAULT_TEXT_COLOR }, items.map(function (_a) {
                                        var key = _a.key, el = _a.el;
                                        return (React.createElement(useDisplayMode_1.DisplayModeContext.Provider, { value: "hamburger", key: "header-link_".concat(key) }, el));
                                    }))))))));
            case 'md':
                return getOffsetContent(2);
            case 'lg':
                return getOffsetContent(4);
            default:
                return (React.createElement(React.Fragment, null, items.map(function (_a) {
                    var key = _a.key, el = _a.el;
                    return (React.createElement(useDisplayMode_1.DisplayModeContext.Provider, { value: "main", key: "header-link_".concat(key) }, el));
                })));
        }
    };
    return React.createElement(react_1.HStack, { spacing: 1 }, getContent(breakpoint));
};
exports.MainNavLinks = MainNavLinks;
var MoreOptionsDropdown = function (_a) {
    var children = _a.children, underlined = _a.underlined;
    var _js = (0, useHeaderProps_1.useHeaderProps)()._js;
    return (React.createElement(NavMenu_1.NavMenu, null,
        React.createElement(NavMenu_1.NavMenuButton, { className: "header-link__more-options", "data-feature-id": "header_link_more_options", underlined: underlined }, _js('More Options')),
        React.createElement(NavMenu_1.NavMenuList, { "data-testid": "more_options_dropdown_content", "data-feature-id": "more_options_dropdown_content" }, children)));
};
